module.exports = __webpack_public_path__ + "media/manuela1.fb0cd4fb.mp3";